var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTemplatesGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.333A2.667 2.667 0 0 1 18.667 4v8A2.667 2.667 0 0 1 16 14.667H4A2.667 2.667 0 0 1 1.333 12V4A2.667 2.667 0 0 1 4 1.333h12zM16 4H4v8h12V4zm12-2.667A2.667 2.667 0 0 1 30.667 4v8A2.667 2.667 0 0 1 28 14.667h-4A2.667 2.667 0 0 1 21.333 12V4A2.667 2.667 0 0 1 24 1.333h4zM28 4h-4v8h4V4zm2.667 16A2.667 2.667 0 0 0 28 17.333h-8A2.667 2.667 0 0 0 17.333 20v8A2.667 2.667 0 0 0 20 30.667h8A2.667 2.667 0 0 0 30.667 28v-8zM20 20h8v8h-8v-8zm-8-2.667A2.667 2.667 0 0 1 14.667 20v8A2.667 2.667 0 0 1 12 30.667H4A2.667 2.667 0 0 1 1.333 28v-8A2.667 2.667 0 0 1 4 17.333h8zM12 20H4v8h8v-8z",
    fill: "#8A8DAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplatesGrey);
export default __webpack_public_path__ + "static/media/icon_templates_grey.c6c11618c79550da1439ff699e470dd2.svg";
export { ForwardRef as ReactComponent };